import { useDispatch } from "react-redux";
import { useQueries } from "../../../../../hooks/services/queries/use-queries";
import { setSelectedPaymentTermBox } from "../../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice";
import { SubTypeOption } from "../../../../../api/gms/group-category/group-category-api-state";
import Label from "../../../../ui/label";
import { Checked } from "../../../../../assets/icon/svg";
import LoadingCategory from "../../../../ui/loading-category";
import ErrorFetch from "../../../../ui/error-fetch-category";
import Checkbox from "../../../../ui/checkbox";
import { useProposalTypeData } from "../../../../../hooks/proposal/use-proposal-type-data";

interface Props {
    isPreview?: boolean;
}

export default function ClientInputPaymentTerm({ isPreview }: Props) {

    const dispatch = useDispatch();
    const { paymentTerm, isLoadingPaymentTerm, isErrorPaymentTerm, } = useQueries()
    const { paymentTerm: selectedPaymentTerm } = useProposalTypeData();
    
    const mappedOptions: SubTypeOption[] = paymentTerm?.map(item => ({
        id: item.id,
        name: item.name
    })) || [];

    const handleChangePaymentTerm = (option: SubTypeOption) => {
        dispatch(setSelectedPaymentTermBox(option))
    }

    return (
        <div className="">
            <div className="flex items-start gap-2.5 border-b border-[#186cb2]/20 bg-[#186cb2]/10 px-3 py-3 sm:px-4">
                {/* TITLE & DESCRIPTION */}
                <div className="min-w-0">
                    <Label
                        label="Payment Term"
                        isRequired={true}
                        requiredText=" *"
                        fontSize="text-xs"
                        fontWeight="font-semibold text-gray-800"
                    />
                    <p className="mt-0.5 text-[10px] leading-4 text-gray-500 sm:text-[11px]">
                        Select the payment term that will apply to this proposal.
                    </p>
                </div>
            </div>

            {isPreview ? (
                <div className="w-full">
                    <div className="flex items-center gap-3 rounded-lg border border-[#186cb2] bg-[#186cb2]/5 px-3 py-3">
                        <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#186cb2] text-white">
                            <Checked />
                        </div>
                        <div className="min-w-0">
                            <p className="text-xs text-gray-500">Selected payment term</p>
                            <p className="truncate text-sm font-semibold text-gray-900">{selectedPaymentTerm?.name || '-'}</p>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={`${isErrorPaymentTerm || isLoadingPaymentTerm ? 'grid-cols-1' : 'grid-cols-1 sm:grid-cols-2 xl:grid-cols-3'} grid gap-2 p-3`}>
                    {isLoadingPaymentTerm ? (
                        <LoadingCategory />
                    ) : isErrorPaymentTerm ? (
                        <ErrorFetch />
                    ) : (
                        mappedOptions.map((option) => {
                            const isSelected = selectedPaymentTerm?.id === option.id;
                            return (
                                <Checkbox
                                    key={option.id}
                                    disabled={false} 
                                    option={option} 
                                    isSelected={isSelected} 
                                    onChange={() => handleChangePaymentTerm(option)}
                                />
                            );
                        })
                    )}
                </div>
            )}
        </div>
    )
}
